import styles from './AppHeader.module.scss';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@casops/store/hooks';
import { VdsHeader, VdsMenuItem, VdsMenuList } from '@volt/volt-extended-components-react';
import { openSidePanel, SidePanel } from '@casops/store/slices/globalSlice';
import { useCallback, useState } from 'react';
import { useLogoutMutation } from '@casops/store/apis/authApi';
import { navToLandingPage } from '@casops/navigation';
import { lockIcon } from '@cas/components/icons/icons';

export function AppHeader() {
  const { t } = useTranslation();

  const userData = useAppSelector(state => state.auth);

  const dispatch = useAppDispatch();

  const [logout] = useLogoutMutation();
  const onLogout = useCallback(async () => {
    await logout().unwrap();
    navToLandingPage();
  }, [logout]);

  const [renderKey, setRenderKey] = useState(0);

  const onChangeSettings = useCallback(() => {
    dispatch(
      openSidePanel({
        sidePanel: SidePanel.UserSettings,
      }),
    );

    // Increment the key so that the header is re-rendered without the menu open.
    // FIXME: This code is a workaround for closing the VdsHeader popup since the component has no methods.
    setRenderKey(prevKey => prevKey + 1);
  }, [dispatch]);

  const onChangePassword = useCallback(() => {
    dispatch(
      openSidePanel({
        sidePanel: SidePanel.UserChangePassword,
      }),
    );

    // Increment the key so that the header is re-rendered without the menu open.
    // FIXME: This code is a workaround for closing the VdsHeader popup since the component has no methods.
    setRenderKey(prevKey => prevKey + 1);
  }, [dispatch]);

  return (
    <VdsHeader
      key={renderKey}
      className={styles.container}
      value={t('DigitalMineCasOps')}
      username={userData.displayName ?? ''}
      avatar={userData.displayName ?? ''}
      showUserSection={userData.isLoggedIn}
    >
      {userData.isLoggedIn && (
        <>
          <div slot="contentSection" className={styles.content}></div>

          <div slot="profilePopupContent">
            <VdsMenuList>
              <VdsMenuItem
                isActive={false}
                size="medium"
                icon={lockIcon}
                value={t('ChangePassword')}
                onClick={onChangePassword}
              />
              <VdsMenuItem
                isActive={false}
                size="medium"
                icon="system"
                value={t('Settings')}
                onClick={onChangeSettings}
              />
              <VdsMenuItem
                isActive={false}
                size="medium"
                icon="logout"
                value={t('SignOut')}
                onClick={onLogout}
              />
            </VdsMenuList>
          </div>
        </>
      )}
    </VdsHeader>
  );
}

export default AppHeader;
